<h4 class="title">Create Client Type</h4>

<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-3">
            <h5 class="form-lable">Client Type:</h5>
            <input type="text" pInputText [(ngModel)]="type" placeholder="Client Type">
        </div>

        <div class="col-md-6 mt-20">
            <button *ngIf="edit_f == false" type="button" class="btn btn-primary" (click)="add()">Add</button>
            <button  *ngIf="edit_f == true" type="button" class="btn btn-primary" (click)="edit()">Update</button>
            <button type="button" *ngIf="edit_f == true" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button>
        </div>

    </div>
</div>
<div class="row">
    <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div>
    <div class="col-md-8 text-right">
        <!-- <button type="button" class="btn btn-primary mr-0" (click)="User_form()" >Add</button>  -->
    </div>
</div>
<div class="doc-table">
<div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="25"
    [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
  
    <ng-template pTemplate="header">
        <tr class="thhead">
            <th class="th-1">
                S.No
            </th>
            <th>
                Client Type
            </th>
            <th>
                Created By
            </th>
            <th>Created At</th>
            <th>Updated At</th>
            <th style="width: 110px;text-align:center">
                Action
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="tdrow">
            <td>{{i+1}}</td>
            <td>{{item.client_type}}</td>
            <td>{{item.addedby}}</td>
            <td>{{item.createdAt}}</td>
            <td>{{item.updatedAt}}</td>
            <td class="act">
                <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit" (click)="show_edit(item)"></i>
                <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete" (click)="delete(item._id)"></i>
            </td>
        </tr>
    </ng-template>
 </p-table>  </div>

</div>